<template>
    <div class="yhzxTable">
        <div class="tit">
            <span>{{ db.tit }}</span>
            <div class="msg">
                温馨提示：如果您申请成为{{ db.type }}，那么您将可能有稳定的{{ db.type }}收益
            </div>
            <div class="apply" @click="applyLotteryTeacher(db.type)">申请{{ db.type }}</div>
        </div>

        <!-- 买入，卖出，收藏 -->
        <div class="nav">
            <div v-for="(item, index) in navType.arr" :key="item.prefix">
                <span :class="navType.active === index ? 'active' : ''" @click="navType.active = index">"{{ item.prefix
                    }}"{{ db.type }}{{ item.suffix }}</span>
            </div>
        </div>

        <!-- 双色球，福彩3D，大乐透，排列三 -->
        <div class="nav1">
            <span v-for="(item, index) in lotteryType.arr" :key="index"
                :class="lotteryType.active === index ? 'active' : ''" @click="lotteryType.active = index">{{ item.label
                }}</span>
        </div>

        <!-- 缩水师，技巧师，投注站，软件交易师 -->
        <div class="table" v-loading="tableLoading">
            <div class="th" :style="gridTemplateColumns">
                <span>序号</span>
                <span v-for="(item, index) in db.title" :key="index">{{ item }}</span>
            </div>

            <template v-if="db.type === '缩水师' && db.list.length">
                <div class="td" v-for="(item, index) in db.list" :key="index" :style="gridTemplateColumns">
                    <span>{{ index + 1 }}</span>
                    <span>{{ item.number }}</span>
                    <span>{{ navType.active === 1 ? item.userName : item.author }}</span>
                    <span>{{ item.preIndexTypeName }}</span>
                    <span>{{ item.backNumber }}中{{ item.correctNum }}期</span>
                    <span>{{ item.coin }}</span>
                    <span>
                        <a v-if="!['PRE_INDEX_SIX', 'PRE_INDEX_FOUR'].includes(item.preIndexTypeAlies)"
                            @click="downFile(item)" href="javascript:">下载 /</a>
                        <a @click="lookCheck()" href="javascript:">查阅</a>
                    </span>
                    <span>{{ item.createTime && item.createTime.substr(0, 16) }}</span>
                </div>
            </template>
            <template v-if="db.type === '技巧师' && db.list.length">
                <div class="td" v-for="(item, index) in db.list" :key="index" :style="gridTemplateColumns">
                    <span>{{ index + 1 }}</span>
                    <span>{{ item.number }}</span>
                    <span>{{ item.author }}</span>
                    <span>{{ item.preIndexTypeName }}</span>
                    <span>{{ item.backNumber }}中{{ item.correctNum }}期</span>
                    <span>{{ item.coin }}</span>
                    <span><a href="javascript:">下载</a>/<a href="javascript:">查阅</a></span>
                    <span>{{ item.createTime && item.createTime.substr(0, 10) }}</span>
                </div>
            </template>
            <template v-if="db.type === '投注站' && db.list.length">
                <div class="td" v-for="(item, index) in db.list" :key="index" :style="gridTemplateColumns">
                    <span>{{ index + 1 }}</span>
                    <span>{{ item.number }}</span>
                    <span>{{ item.author }}</span>
                    <span>{{ item.preIndexTypeName }}</span>
                    <span>{{ item.backNumber }}中{{ item.correctNum }}期</span>
                    <span>{{ item.coin }}</span>
                    <span><a href="javascript:">下载</a>/<a href="javascript:">查阅</a></span>
                    <span>{{ item.createTime && item.createTime.substr(0, 10) }}</span>
                </div>
            </template>
            <template v-if="db.type === '软件交易师' && db.list.length">
                <div class="td" v-for="(item, index) in db.list" :key="index" :style="gridTemplateColumns">
                    <span>{{ index + 1 }}</span>
                    <span>{{ item.number }}</span>
                    <span>{{ item.author }}</span>
                    <span>{{ item.preIndexTypeName }}</span>
                    <span>{{ item.backNumber }}中{{ item.correctNum }}期</span>
                    <span>{{ item.coin }}</span>
                    <span @click="downFile(item.preIndexTypeAlies, item.recordId)">
                        <span href="javascript:;">下载123</span>/
                        <span href="javascript:;">查阅</span>
                    </span>
                    <span>{{ item.createTime && item.createTime.substr(0, 10) }}</span>
                </div>
            </template>

        </div>

        <!-- <pay ref="pay"
             @pay_downFile_progress="pay_downFile_progress"
             @look_downFile="look_downFile" /> -->
        <pay ref="pay" />

        <el-pagination style="padding-top:20px;text-align:right" background layout="prev, pager, next"
            @current-change="changePage" :page-size="queryParams.pageSize" :total="queryParams.total">
        </el-pagination>
        <div class="divider"></div>
    </div>
</template>

<script>
import { salesInCount, salesOutCount } from "@/api/yhzx"
import { createOrder } from "@/api/common"


import pay from "@/components/pay.vue";

export default {
    props: ["db"],
    components: {
        pay
    },
    data() {
        return {
            tableLoading: false,

            navType: {
                arr: [
                    { prefix: '买入', suffix: '数据' },
                    { prefix: '卖出', suffix: '数据' },
                    { prefix: '收藏', suffix: '' },
                ],
                active: 0
            },

            lotteryType: {
                arr: [],
                active: 0,
            },

            queryParams: {
                preType: 0,
                productModel: 0,

                pageNum: 1,
                pageSize: 10,
                total: 0,

            },

        };
    },
    computed: {
        gridTemplateColumns() {
            const titles = this.db.title || []
            // 表头文字越长，该列占比越大（避免"上期图表准确率"这类长标题被挤成竖排）；
            // 权重限制在 3~8 之间，"价格/备注/操作"等短标题不会被分到过窄
            const weights = titles.map(t => Math.min(Math.max(String(t).length, 3), 8))
            weights.unshift(3) // 序号列
            return `grid-template-columns: ${weights.map(w => `${w}fr`).join(' ')};`;
        }
    },
    watch: {
        'navType.active'() {
            this.tableLoading = true
            // eslint-disable-next-line vue/no-mutating-props
            this.db.list = []
            this.init()
        },
        'lotteryType.active'(val) {
            this.tableLoading = true
            // eslint-disable-next-line vue/no-mutating-props
            this.db.list = []
            this.queryParams.preType = val
            this.init()
        }
    },
    mounted() {
        console.log('db', JSON.parse(JSON.stringify(this.db)));

        this.queryParams.preType = this.lotteryType.active
        this.queryParams.productModel = this.db.productModel

        this.tableLoading = true
        this.init()

        this.getLottery()
    },
    methods: {
        // 分页状态变化
        changePage(e) {
            this.tableLoading = true
            this.queryParams.pageNum = e
            this.init();
        },
        getLottery() {

            this.$http.get('/stage-api/system/dict/data/type/pre_type').then(res => {
                // 接口未返回 data 时做兜底，避免 .map 报错
                const arr = (res && res.data) || []
                this.lotteryType.arr = arr.map(item => {
                    return {
                        label: item.dictLabel,
                        value: item.dictValue,
                    }
                })

            }).catch(err => {
                console.log('getLottery error', err);
                this.lotteryType.arr = []
            })
        },


        init() {

            // salesInCount: 进口数据
            // salesOutCount: 出口数据
            // '': 收藏

            let mapping = [salesInCount, salesOutCount, '']
            let func = mapping[this.navType.active]

            console.log('this.queryparamsaaaaa', this.queryParams);

            if (func) {
                func(this.queryParams).then(res => {
                    this.tableLoading = false;
                    // 接口未返回 data 时做兜底，避免 .rows/.total 报错
                    const data = (res && res.data) || {}
                    // eslint-disable-next-line vue/no-mutating-props
                    this.db.list = data.rows || [];
                    this.queryParams.total = data.total || 0

                }).catch(err => {
                    console.log('init error', err);
                    this.tableLoading = false
                    // eslint-disable-next-line vue/no-mutating-props
                    this.db.list = []
                })
            } else {
                this.tableLoading = false
                // eslint-disable-next-line vue/no-mutating-props
                this.db.list = []
            }

        },
        applyLotteryTeacher(type) {
            const typeToUrlMap = {
                '缩水师': '/personalCenter/hangjiaguanli/apply_sss',
                '技巧师': '/personalCenter/hangjiaguanli/apply_jqs',
                '软件交易师': '/personalCenter/suoshuiruanjian/apply_jys',
                '投注站': '/personalCenter/tzz_bf/cp_tzz_sq_bf'
            };

            let url = typeToUrlMap[type] || '';
            this.$router.push(url);
        },

        // 下载附件
        async downFile(item) {
            console.log('item', JSON.parse(JSON.stringify(item)));
            let { preType, preIndexType, number, authorId } = item
            let params = { preType, preIndexType, number, createUser: authorId, }
            let queryRes = await this.$http.post('/stage-api/pre/record/queryDownloadFilePriceByRecordId', params)
            let queryData = (queryRes && queryRes.data) || {}
            if (!queryData.orderNo && !queryData.price) {
                // 接口未返回下载信息，避免脏调用与报错
                this.$message.error('获取下载信息失败，请稍后重试')
                return
            }
            let { orderNo, price, productId, specsId } = queryData

            if (orderNo) {
                // 下载文件
                alert('下载文件')
                // this.downloadFile(orderNo, price, item, preIndexTypeLabel)
            } else {
                if (price) {
                    let payDb = {
                        avatar: process.env.VUE_APP_BASE_API + 'stage-api' + item.avatar,
                        title: item.title,
                        nickName: item.author,
                        number: item.number,
                        shrinkId: item.authorId,
                        indexName: item.preIndexTypeName,
                        strJson: item.coin,
                        lotteryType: item.preType,
                        price, productId, specsId,
                    }
                    console.log('payDb', payDb);
                    // this.$emit('view_download', payDb)

                    this.$refs.pay.init(payDb)
                } else {
                    let resCreateOrder = await this.fun_createOrder(price, item, productId, specsId)
                    if (!resCreateOrder) {
                        return;
                    }
                    console.log('resCreateOrder----------------', resCreateOrder);
                    // 下载文件
                    this.downloadFile(resCreateOrder, price, item)
                }

            }
        },
        // 查阅
        lookCheck() {
            this.$message.error('正在开发中...')
        },


        // 创建订单
        async fun_createOrder(price, item, productId, specsId) {
            let lotteryType = ['双色球', '大乐透', '福彩3D', '体彩排三']
            // 创建订单号
            let params = {
                money: price,
                productAuthor: item.authorId,	//商家id
                productId,
                productSpecsId: specsId,
                payType: 'balancepay',
                productModel: 0,
                quantity: 1,
                title: `${lotteryType[item.preType * 1]} - ${item.author} - ${item.number}`,
                uuid: new Date().getTime(),
            }

            console.log('params----------', params);

            let resCreateOrder = await createOrder(params)
            if (resCreateOrder.code === 500) {
                this.$message.error(resCreateOrder.msg)
                return null;
            }
            console.log('resCreateOrder', resCreateOrder);

            return (resCreateOrder.data && resCreateOrder.data.orderNo) || ''
        },
        // 下载文件
        downloadFile(orderNo, price, item) {
            let lotteryType = ['双色球', '大乐透', '福彩3D', '体彩排三']
            let that = this

            this.$confirm('您确定下载该缩水单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get('/stage-api/pre/detail/zipDownload', {
                    params: { orderNo, coin: price },
                    headers: { 'Authorization': 'Bearer ' + this.vuex_token },
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        that.$vuex('vuex_downFile_progress', percentCompleted >= 100 ? false : percentCompleted)
                    },
                }).then(downRes => {
                    if (downRes.code === 500) { return this.$message.error(downRes.msg) }
                    let fileName = `${lotteryType[item.preType * 1]}-${item.number}期-${item.nickName}-${item.preIndexTypeName}.zip`
                    this.$utils.downloadFile(downRes, fileName, 'application/zip')
                })
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.yhzxTable {
    margin-top: 20px;

    .tit {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        font-size: 15px;

        span {
            background-color: #015fa4;
            color: #fff;
            padding: 10px;
        }

        .msg {
            font-weight: bold;
            color: #347cc0;
        }

        .apply {
            border: 1px solid #eeb571;
            color: #eeb571;
            padding: 10px 30px;
        }
    }

    .nav {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;

        >div {
            flex: 1;
            border: 1px solid rgba(0, 0, 0, 0.08);
            text-align: center;

            span {
                cursor: pointer;
                margin: 10px 0;
                border-radius: 10px;
                background-color: #93d2f3;
                padding: 10px;
                display: inline-block;

                &.active {
                    background-color: #015fa4;
                    color: #fff;
                }
            }
        }
    }

    .nav1 {
        display: flex;

        span {
            flex: 1;
            border: 1px solid rgba(0, 0, 0, 0.08);
            text-align: center;
            padding: 10px;
            cursor: pointer;
            /* 未选中：浅蓝底 */
            background-color: #93d2f3;
            transition: background-color 0.2s, color 0.2s;

            &:hover {
                background-color: #5cb8e8;
            }

            /* 选中：深蓝底白字，与买入/卖出那行保持一致 */
            &.active {
                background-color: #015fa4;
                color: #fff;
            }
        }
    }

    .table {
        width: 100%;
        text-align: center;
        min-height: 300px;

        >div {
            display: grid;
            // grid-template-columns: repeat(8, 1fr);
            grid-template-rows: auto;

            span {
                padding: 10px 0;
                border: 1px solid rgba(0, 0, 0, 0.08);
            }
        }

        /* 表头：品牌蓝底白字加粗，与下面的数据行一眼区分开 */
        >.th span {
            background-color: #347caf;
            color: #ffffff;
            font-weight: 700;
        }
    }

    .divider {
        background-color: #ebebeb;
        width: 100%;
        height: 2px;
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    .yhzxTable {
        margin-top: 14px;

        /* 标题行：允许换行 */
        .tit {
            flex-wrap: wrap;
            row-gap: 8px;

            .msg {
                font-size: 12px;
                line-height: 1.7;
            }

            .apply {
                padding: 8px 16px;
                font-size: 13px;
            }
        }

        /* 买入/卖出/收藏：尽量一行排下，放不下自动换行 */
        .nav {
            flex-wrap: wrap;

            >div {
                flex: 1 1 auto;
                min-width: 96px;
                margin: 4px;

                span {
                    margin: 6px 0;
                    padding: 8px 2px;
                    font-size: 12px;
                    line-height: 1.4;
                }
            }
        }

        /* 彩种切换 */
        .nav1 span {
            padding: 8px 2px;
            font-size: 12px;
        }

        /* 数据表格：保持列宽可读，由内容区横向滚动查看 */
        .table {
            min-width: 720px;

            span {
                padding: 8px 2px;
                font-size: 12px;
                word-break: break-word;
            }
        }
    }
}
</style>
